import React, { useState } from "react";
import { Container, Row, Col, Button, Form, Alert } from "react-bootstrap";
import api from "../api";

function Home() {
  const [formData, setFormData] = useState({
    name: "",
    firstname: "",
    email: "",
    phone: "",
    comment: "",
    pro: false,
  });

  const [status, setStatus] = useState({ success: null, message: "" });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus({ success: null, message: "" });

    try {
      const response = await api.post("/contact_me", formData);
      setStatus({
        success: true,
        message: response.data.message == 'Contact form submitted' && 'Thank you! See you soon.' || "Message sent!",
      });
      setFormData({
        name: "",
        firstname: "",
        email: "",
        phone: "",
        comment: "",
        pro: false,
      });
    } catch (error) {
      let message = "An error occurred. Please try again.";
      const detail = error.response?.data?.detail;

      if (typeof detail === "string") {
        message = detail;
      } else if (Array.isArray(detail)) {
        message = detail.map((d) => d.msg).join("; ");
      }

      setStatus({ success: false, message });
    }
  };

  return (
    <Container className="text-center mt-5 comic-neue">
      <h1>
        <img
          src="/logo_central.png"
          alt="Pic-Loud Logo"
          style={{ width: "auto", height: "130px" }}
        />
      </h1>
      <div className="lead mt-3">
        <span className="d-block">
          Share your pictures with AI face recognition search.
        </span>
        <span className="d-block">
          Just upload, share a URL, generate a QR code and more.
        </span>
      </div>

      <Row className="justify-content-center mt-5 comic-neue">
        <Col md={6}>
          {
          status.message && (
            <Alert variant={status.success ? "success" : "danger"}>
              {status.message}
            </Alert>
          ) 
          }
          {/* Form */}
          { !status.success && (
            <>
              <h2>Contact Us</h2>
              <Form onSubmit={handleSubmit}>
                <Form.Group controlId="firstname" className="mb-3">
                  <Form.Control
                    type="text"
                    placeholder="First Name"
                    name="firstname"
                    value={formData.firstname}
                    onChange={handleChange}
                  />
                </Form.Group>
                <Form.Group controlId="name" className="mb-3">
                  <Form.Control
                    type="text"
                    placeholder="Last Name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                  />
                </Form.Group>
                <Form.Group controlId="email" className="mb-3">
                  <Form.Control
                    type="email"
                    placeholder="Your Email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
                <Form.Group controlId="phone" className="mb-3">
                  <Form.Control
                    type="phone"
                    placeholder="Phone Number"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                  />
                </Form.Group>
                <Form.Group controlId="comment" className="mb-3">
                  <Form.Control
                    as="textarea"
                    rows={4}
                    placeholder="Your Message"
                    name="comment"
                    value={formData.comment}
                    onChange={handleChange}
                  />
                </Form.Group>
                <Form.Group controlId="pro" className="mb-3 text-start">
                  <Form.Check
                    type="checkbox"
                    label="I'm a pro (business contact)"
                    name="pro"
                    checked={formData.pro}
                    onChange={handleChange}
                  />
                </Form.Group>
                <Button variant="outline-secondary" type="submit">
                  Let's go!
                </Button>
              </Form>
            </>
          )}
        </Col>
      </Row>
    </Container>
  );
}

export default Home;
